export default "__VITE_PUBLIC_ASSET__fef63f2f__"